import React from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import { exchangeCodeForToken } from '../../../sessionMonster';
import { history } from '../../../history';
import { store } from '../../../store';

export class Callback extends React.Component {
  constructor(props) {
    super(props);
    this.exchangeCodeAndRoute = this.exchangeCodeAndRoute.bind(this);
  }

  exchangeCodeAndRoute() {
    const { location } = this.props;
    const { search } = location;
    let queryParameters = {};
    if (search.length) {
      queryParameters = qs.parse(search.split('?')[1]);
    }
    const { code, state } = queryParameters;
    if (code && state) {
      exchangeCodeForToken({ code, state }, store);
    } else {
      history.push('/view');
    }
  }

  componentDidMount() {
    this.exchangeCodeAndRoute();
  }

  componentDidUpdate() {
    this.exchangeCodeAndRoute();
  }

  render() {
    return (<div />);
  }
}

Callback.propTypes = {
  location: PropTypes.shape({ search: PropTypes.string }).isRequired,
};
